import { RequestProvider } from '@/shared/providers/request.provider';
import { TOOLS_API } from '../values/tools.values'

class ToolServicesClass {

  /* Get Methods */
  public async getInstitutionData(): Promise<any> {
    return RequestProvider.get(TOOLS_API.INSTITUTION_INFO);
  }

  public async getInstitutionSDA(id: number): Promise<any> {
    return RequestProvider.get(`${TOOLS_API.SDA_INSTITUTION}/${id}/users/SDA?pageSize=20`);
  }

  public async getCountries(): Promise<any> {
    return RequestProvider.requestPublic('GET', TOOLS_API.COUNTRIES);  
  }

  /* Put Methods */
  public async updateInstitutionInfo(data: any): Promise<any> {
    return RequestProvider.put(TOOLS_API.UPDATE_INSTITUTION_INFO, data);
  }

}

export const ToolServices = new ToolServicesClass();